import { createContext, useContext } from 'react';

export type TestingTag = 'none' | 'side-nav' | 'body' | 'top-nav';

export const TestingTagContext = createContext<{ tag: TestingTag }>({
    tag: 'none',
});

export const useTestingTagContext = () => {
    return useContext(TestingTagContext);
};
